import { render, staticRenderFns } from "./StandingOrders.vue?vue&type=template&id=c4f7db2c&scoped=true&"
import script from "./StandingOrders.vue?vue&type=script&lang=js&"
export * from "./StandingOrders.vue?vue&type=script&lang=js&"
import style0 from "./StandingOrders.vue?vue&type=style&index=0&id=c4f7db2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f7db2c",
  null
  
)

export default component.exports